import { applyMiddleware, combineReducers, createStore } from 'redux';

import { ISessionState, sessionReducers } from '~/src/dash/reducers/session-reducers';
import { IUserState, userReducers } from '~/src/dash/reducers/user-reducers';

export interface IStore {
  user: IUserState;
  session: ISessionState;
}

export const store = createStore(
  combineReducers({
    user: userReducers,
    session: sessionReducers,
  } as any),
  applyMiddleware(),
);
